;
define("site_search.tpl", function(){});

